export default {
  INVITATIONS: [
    {
      hed: 'Welcome and congrats! Can you tell us your names?',
      hed_mobile: 'Can you tell us your names?',
      dek: 'We\'ll add them to your Invites + Paper design.',
    },
    {
      dek: 'We\'ll add your date to your Invites + Paper design, too.',
      cta: 'Customize Your Design'
    }
  ],
  SAVE_THE_DATE: [
    {
      hed: 'Welcome and congrats! Can you tell us your names?',
      hed_mobile: 'Can you tell us your names?',
      dek: 'We\'ll add them to your Invites + Paper design.',
    },
    {
      dek: 'We\'ll add your date to your Invites + Paper design, too.',
      cta: 'Customize Your Design'
    }
  ],
  REGISTRY_ONBOARD_WITH_SLUG: [
    {},
    {
      cta: 'Last Step: Web Address'
    }
  ]
};



/** WEBPACK FOOTER **
 ** ./src/components/onboard/stepCopy.js
 **/